interface Number {
    toTwoFractionDigits(): number;
}

Number.prototype.toTwoFractionDigits = function (this: number)  {
    return Number(this.toFixed(2));
};